import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {ObjectIdModule} from '../../modules/models'
import {BedModel} from '../model'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function deleteBedService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<BedModel>>(`${BASEURL}/bed/deleteBed`, {
    data: dto,
  })
}
